import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './SubaruLogo.svg';

/**
 * @function
 * Auto-generated file.
 */
export const SubaruLogo = React.forwardRef<SVGSVGElement, SvgIconProps>(function SubaruLogo(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 200 45" component={Icon} {...props} />
  );
});
